import {
  Component,
  Input,
  OnInit,
  OnDestroy,
} from '@angular/core';
import * as _ from 'lodash';
import { Subscription } from 'rxjs';

import * as utils from 'utils/utils';
import { segmentsData } from '../../../product-details/segments-data-stub';
import { BaseSegmentComponent } from '../base/_base-segment.component';


@Component({
  moduleId: module.id,
  selector: 'ecommerce-overview',
  templateUrl: 'overview.component.html',
  styleUrls: ['overview.component.scss'],
})
export class OverviewComponent extends BaseSegmentComponent implements OnInit, OnDestroy {

  descriptionsMKT: any;
  descriptionsASC: any;

  fields: Array<string> = ['descriptions.MKT', 'descriptions.ASC'];

  productData: any = [];
  partTypeData: any = [];

  private subscription: Subscription;

  get comments(): any {
    return this.getDescriptionProperty(this.descriptionsASC);
  }

  ngOnInit() {
    this.setSegmentItems();
    this.subscription = this.dataChange.subscribe(() => {
      this.setProductsData();
    });
    this.setProductsData();
  }

  ngOnDestroy() {
    if (this.subscription) {  this.subscription.unsubscribe(); }
  }

  getRefLowerCase(ref: string): string {
    return _.lowerCase(ref);
  }

  // private
  private setSegmentItems() {
    this.descriptionsMKT = _.find(
      segmentsData.descriptions,
      ['item_name', 'descriptions.MKT']
    );
    this.descriptionsASC = _.find(
      segmentsData.descriptions,
      ['item_name', 'descriptions.ASC']
    );
  }

  private setProductsData() {
    this.productData = this.groupMarketingByType(this.groupMarketingByCode('product_groups'));
    this.partTypeData = this.groupMarketingByType(this.groupMarketingByCode('part_type'));
  }
}
